const PROTOCOL = `${window.location.protocol}//`;
const APP_BASE_DOMAIN = window.location.host;
const PLATFORM_BASE_PATH = "a";
// const APP_BASE_DOMAIN = 'was-http.bluefabric.ch';

const APP_BASE_PATH = PROTOCOL + APP_BASE_DOMAIN;

const REST_PATH = `${APP_BASE_PATH}/fabric/api`;

const ENGINE_REST_PATH = `${APP_BASE_PATH}/engine/api`;

const PORTAL_REST_PATH = "https://camunda-test.hq.agys.ch";

const PRIMITIVES = ["String", "Date", "Time", "DateTime", "Integer", "Boolean", "Decimal", "Attachment"];
const DATE_PRIMITIVES = ["date", "time", "datetime"];
const APP_DATE_HYPHEN_FORMAT = "DD-MM-YYYY HH:mm:ss";
const APP_DATE_DOT_FORMAT = "DD.MM.YYYY HH:mm:ss";
const APP_DATE_DOT_FORMAT_AM_PM = "DD.MM.YYYY hh:mm A";
const APP_DATE_DOT_FORMAT_NO_SEC = "DD.MM.YYYY hh:mm";
const APP_DATE_LINE_FORMAT_NO_SEC = "DD-MM-YYYY hh:mm";
const APP_DATE_SLASH = "YYYY/MM/DD";
const APP_DATE_LINE_FORMAT = "DD-MM-YYYY";
const APP_DATE_MONTH_LETTERS_FORMAT = "DD MMMM YYYY";
const CATALOGS_DATE_LINE_FORMAT = "YYYY-MM-DD";
const CATALOGS_TIME_LINE_FORMAT = "HH:mm:ssZ";
const CATALOGS_TIME_LINE_FORMAT_SHOW = "HH:mm:ss";
const CATALOGS_DATE_TIME_LINE_FORMAT = "YYYY-MM-DD HH:mm:ssZ";
const CATALOGS_DATE_TIME_LINE_FORMAT_SHOW = "YYYY-MM-DD HH:mm:ss";
const APP_TIME_FORMAT_AM_PM = "hh:mm A";
const BASIC_TIME_FORMAT = "HH:mm";
const APP_DATETIME_SLASH = "YYYY/MM/DD HH:mm";
const APP_DATE_DOT_DMY_FORMAT = "DD.MM.YYYY";
const APP_DATE_HOUR_MIN_FORMAT = "YYYY-MM-DD HH:mm";
const CONDITIONS_TIME_PAYLOAD_FORMATS = Object.freeze({
    time: "HH:mm:ssZ",
    date: "YYYY-MM-DD",
    datetime: "YYYY-MM-DDTHH:mm:ssZ"
});
const CONDITION_TIME_USER_FORMATS = Object.freeze({
    time: "HH:mm",
    date: "YYYY-MM-DD",
    datetime: "YYYY-MM-DD HH:mm:ss"
});
const STANDARD_CHECK_NAME_REGEX = "^[a-zA-Z0-9]*[a-zA-Z_][a-zA-Z0-9_]*$";
const CHECK_NAME_REGEX_STARTING_ALPHA_ONLY = "^[a-zA-Z]*[a-zA-Z_][a-zA-Z0-9_]*$";
const GROUP_NAME_CHECK_REGEX = "^(?!.* $)[a-zA-Z0-9]*[a-zA-Z_][a-zA-Z0-9_\\s]*$";
export {
    APP_DATE_HYPHEN_FORMAT, CATALOGS_DATE_TIME_LINE_FORMAT_SHOW, CATALOGS_DATE_TIME_LINE_FORMAT,
    CATALOGS_TIME_LINE_FORMAT_SHOW, CATALOGS_DATE_LINE_FORMAT, CATALOGS_TIME_LINE_FORMAT,
    APP_DATETIME_SLASH, APP_DATE_SLASH, APP_DATE_DOT_FORMAT, APP_DATE_LINE_FORMAT_NO_SEC,
    APP_DATE_HOUR_MIN_FORMAT, APP_DATE_DOT_FORMAT_NO_SEC, ENGINE_REST_PATH, REST_PATH,
    PORTAL_REST_PATH, PRIMITIVES, DATE_PRIMITIVES, CONDITIONS_TIME_PAYLOAD_FORMATS,
    CONDITION_TIME_USER_FORMATS, APP_DATE_DOT_DMY_FORMAT, APP_DATE_LINE_FORMAT,
    APP_DATE_MONTH_LETTERS_FORMAT, APP_TIME_FORMAT_AM_PM, BASIC_TIME_FORMAT, APP_DATE_DOT_FORMAT_AM_PM, STANDARD_CHECK_NAME_REGEX,
    GROUP_NAME_CHECK_REGEX, CHECK_NAME_REGEX_STARTING_ALPHA_ONLY, PLATFORM_BASE_PATH
};
